<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <wbo-date-range-report-criteria></wbo-date-range-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-rows>
                    <fui-row>
                        <fui-four-columns>
                            <fui-column>
                                <wbo-single-select-edit-control [(ngModel)]="model.data.invoiceDateRangeSubType"
                                                                [allowClearSelectionOption]="false"
                                                                [formControlName]="'invoiceDateRangeSubType'">
                                    <wbo-select-options>
                                        <wbo-select-option [value]="'Invoice Date'"
                                                           label="wbo.invoice-summary-report.option.invoiceDateRangeSubType.invoiceDate"></wbo-select-option>
                                        <wbo-select-option [value]="'Processed Date'"
                                                           label="wbo.invoice-summary-report.option.invoiceDateRangeSubType.processedDate"></wbo-select-option>
                                    </wbo-select-options>
                                </wbo-single-select-edit-control>
                            </fui-column>
                            <fui-column>
                                <wbo-detail-report-criteria></wbo-detail-report-criteria>
                            </fui-column>
                            <fui-column>
                                <wbo-checkbox-edit-control [(ngModel)]="model.data.includeCreditInvoices"
                                                           [formControlName]="'includeCreditInvoices'"></wbo-checkbox-edit-control>
                            </fui-column>
                        </fui-four-columns>
                    </fui-row>
                </fui-rows>
            </fui-row>
            <fui-row>
                <wbo-supplier-report-selection></wbo-supplier-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
